
(function () {

    Number.prototype.formatMoney = function (c, d, t) {
        var n = this,
            c = isNaN(c = Math.abs(c)) ? 2 : c,
            d = d == undefined ? "." : d,
            t = t == undefined ? "," : t,
            s = n < 0 ? "-" : "",
            i = parseInt(n = Math.abs(+n || 0).toFixed(c)) + "",
            j = (j = i.length) > 3 ? j % 3 : 0;
        return s + (j ? i.substr(0, j) + t : "") +
            i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) +
            (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "");
    };

    var today = new Date(),
        year = today.getFullYear(),
        startAmount = 0,
        secInYear = 31536000,
        counter = document.getElementById('countloss'),
        startOfDate = new Date(today.getFullYear(), 0, 1, 0, 0, 0),
        lossPerSec = 0,
        lossPerSec2014 = 10.7473,
        lossPerSec2015 = 17.7136,
        lossPerSec2016 = 22.8091,
        lossPerSec2017 = 22.3214,
        lossPerSec2018 = 22.7518,
        lossPerSec2019 = 23.1878,
        lossPerSec2020 = 23.1158,
        lossPerSec2021 = 23.8122,
        lossPerSec2022 = 24.5295,
        lossPerSec2023 = 25.2685,
        lossPerSec2024 = 23.55,
        lossPerSec2025 = 24.76,
        lossPerSec2026 = 22.78,
        lossPerSec2027 = 23.94,
        lossPerSec2028 = 25.16,
        lossPerSec2029 = 26.45,
        lossPerSec2030 = 27.79,
        lossPerSec2031 = 29.21,
        lossPerSec2032 = 30.70;
        /**
         * 02.06.2024
         * See csv data in /private dir or /wp-content/uploads/private/
         */

    if (year == 2014) {
        lossPerSec = lossPerSec2014;
    } else if (year == 2015) {
        lossPerSec = lossPerSec2015;
        startAmount = secInYear * lossPerSec2014;


    } else if (year == 2016) {
        lossPerSec = lossPerSec2016;
        startAmount = (secInYear * lossPerSec2015) + (secInYear * lossPerSec2014);


    } else if (year == 2017) {
        lossPerSec = lossPerSec2017;
        startAmount = (secInYear * lossPerSec2016) + (secInYear * lossPerSec2015) + (secInYear * lossPerSec2014);


    } else if (year == 2018) {
        lossPerSec = lossPerSec2018;
        startAmount = (secInYear * lossPerSec2017) + (secInYear * lossPerSec2016) + (secInYear * lossPerSec2015) + (secInYear * lossPerSec2014);


    } else if (year == 2019) {
        lossPerSec = lossPerSec2019;
        startAmount = (secInYear * lossPerSec2018) + (secInYear * lossPerSec2017) + (secInYear * lossPerSec2016) + (secInYear * lossPerSec2015) + (secInYear * lossPerSec2014);


    } else if (year == 2020) {
        lossPerSec = lossPerSec2020;
        startAmount = (secInYear * lossPerSec2019) + (secInYear * lossPerSec2018) + (secInYear * lossPerSec2017) + (secInYear * lossPerSec2016) + (secInYear * lossPerSec2015) + (secInYear * lossPerSec2014);


    } else if (year == 2021) {
        lossPerSec = lossPerSec2021;
        startAmount = (secInYear * lossPerSec2020) + (secInYear * lossPerSec2019) + (secInYear * lossPerSec2018) + (secInYear * lossPerSec2017) + (secInYear * lossPerSec2016) + (secInYear * lossPerSec2015) + (secInYear * lossPerSec2014);


    } else if (year == 2022) {
        lossPerSec = lossPerSec2022;
        startAmount = (secInYear * lossPerSec2021) + (secInYear * lossPerSec2020) + (secInYear * lossPerSec2019) + (secInYear * lossPerSec2018) + (secInYear * lossPerSec2017) + (secInYear * lossPerSec2016) + (secInYear * lossPerSec2015) + (secInYear * lossPerSec2014);


    }
    else if (year == 2023) {
        lossPerSec = lossPerSec2023;
        startAmount = (secInYear * lossPerSec2022) + (secInYear * lossPerSec2021) + (secInYear * lossPerSec2020) + (secInYear * lossPerSec2019) + (secInYear * lossPerSec2018) + (secInYear * lossPerSec2017) + (secInYear * lossPerSec2016) + (secInYear * lossPerSec2015) + (secInYear * lossPerSec2014);
    }
    else if (year == 2024) {
        lossPerSec = lossPerSec2024;
        startAmount = (secInYear * lossPerSec2023) + (secInYear * lossPerSec2022) + (secInYear * lossPerSec2021) + (secInYear * lossPerSec2020) + (secInYear * lossPerSec2019) + (secInYear * lossPerSec2018) + (secInYear * lossPerSec2017) + (secInYear * lossPerSec2016) + (secInYear * lossPerSec2015) + (secInYear * lossPerSec2014);
    }
    else if (year == 2025) {
        lossPerSec = lossPerSec2025;
        startAmount = (secInYear * lossPerSec2024) + (secInYear * lossPerSec2023) + (secInYear * lossPerSec2022) + (secInYear * lossPerSec2021) + (secInYear * lossPerSec2020) + (secInYear * lossPerSec2019) + (secInYear * lossPerSec2018) + (secInYear * lossPerSec2017) + (secInYear * lossPerSec2016) + (secInYear * lossPerSec2015) + (secInYear * lossPerSec2014);
    }
    else if (year == 2026) {
        lossPerSec = lossPerSec2026;
        startAmount = (secInYear * lossPerSec2025) + (secInYear * lossPerSec2024) + (secInYear * lossPerSec2023) + (secInYear * lossPerSec2022) + (secInYear * lossPerSec2021) + (secInYear * lossPerSec2020) + (secInYear * lossPerSec2019) + (secInYear * lossPerSec2018) + (secInYear * lossPerSec2017) + (secInYear * lossPerSec2016) + (secInYear * lossPerSec2015) + (secInYear * lossPerSec2014);
    }
    else if (year == 2027) {
        lossPerSec = lossPerSec2027;
        startAmount = (secInYear * lossPerSec2026) + (secInYear * lossPerSec2025) + (secInYear * lossPerSec2024) + (secInYear * lossPerSec2023) + (secInYear * lossPerSec2022) + (secInYear * lossPerSec2021) + (secInYear * lossPerSec2020) + (secInYear * lossPerSec2019) + (secInYear * lossPerSec2018) + (secInYear * lossPerSec2017) + (secInYear * lossPerSec2016) + (secInYear * lossPerSec2015) + (secInYear * lossPerSec2014);
    }
    else if (year == 2028) {
        lossPerSec = lossPerSec2028;
        startAmount = (secInYear * lossPerSec2027) + (secInYear * lossPerSec2026) + (secInYear * lossPerSec2025) + (secInYear * lossPerSec2024) + (secInYear * lossPerSec2023) + (secInYear * lossPerSec2022) + (secInYear * lossPerSec2021) + (secInYear * lossPerSec2020) + (secInYear * lossPerSec2019) + (secInYear * lossPerSec2018) + (secInYear * lossPerSec2017) + (secInYear * lossPerSec2016) + (secInYear * lossPerSec2015) + (secInYear * lossPerSec2014);
    }
    else if (year == 2029) {
        lossPerSec = lossPerSec2029;
        startAmount = (secInYear * lossPerSec2028) + (secInYear * lossPerSec2027) + (secInYear * lossPerSec2026) + (secInYear * lossPerSec2025) + (secInYear * lossPerSec2024) + (secInYear * lossPerSec2023) + (secInYear * lossPerSec2022) + (secInYear * lossPerSec2021) + (secInYear * lossPerSec2020) + (secInYear * lossPerSec2019) + (secInYear * lossPerSec2018) + (secInYear * lossPerSec2017) + (secInYear * lossPerSec2016) + (secInYear * lossPerSec2015) + (secInYear * lossPerSec2014);
    }
    else if (year == 2030) {
        lossPerSec = lossPerSec2030;
        startAmount = (secInYear * lossPerSec2029) + (secInYear * lossPerSec2028) + (secInYear * lossPerSec2027) + (secInYear * lossPerSec2026) + (secInYear * lossPerSec2025) + (secInYear * lossPerSec2024) + (secInYear * lossPerSec2023) + (secInYear * lossPerSec2022) + (secInYear * lossPerSec2021) + (secInYear * lossPerSec2020) + (secInYear * lossPerSec2019) + (secInYear * lossPerSec2018) + (secInYear * lossPerSec2017) + (secInYear * lossPerSec2016) + (secInYear * lossPerSec2015) + (secInYear * lossPerSec2014);
    }
    else if (year == 2031) {
        lossPerSec = lossPerSec2031;
        startAmount = (secInYear * lossPerSec2030) + (secInYear * lossPerSec2029) + (secInYear * lossPerSec2028) + (secInYear * lossPerSec2027) + (secInYear * lossPerSec2026) + (secInYear * lossPerSec2025) + (secInYear * lossPerSec2024) + (secInYear * lossPerSec2023) + (secInYear * lossPerSec2022) + (secInYear * lossPerSec2021) + (secInYear * lossPerSec2020) + (secInYear * lossPerSec2019) + (secInYear * lossPerSec2018) + (secInYear * lossPerSec2017) + (secInYear * lossPerSec2016) + (secInYear * lossPerSec2015) + (secInYear * lossPerSec2014);
    }
    else if (year == 2032) {
        lossPerSec = lossPerSec2032;
        startAmount = (secInYear * lossPerSec2031) + (secInYear * lossPerSec2029) + (secInYear * lossPerSec2028) + (secInYear * lossPerSec2027) + (secInYear * lossPerSec2026) + (secInYear * lossPerSec2025) + (secInYear * lossPerSec2024) + (secInYear * lossPerSec2023) + (secInYear * lossPerSec2022) + (secInYear * lossPerSec2021) + (secInYear * lossPerSec2020) + (secInYear * lossPerSec2019) + (secInYear * lossPerSec2018) + (secInYear * lossPerSec2017) + (secInYear * lossPerSec2016) + (secInYear * lossPerSec2015) + (secInYear * lossPerSec2014);
    }



    if (counter) {
        setInterval(function () {
            var today = new Date(),
                todayInMilSec = today.getTime() - startOfDate.getTime();
            var totalLoss = startAmount + ((todayInMilSec / 1000) * lossPerSec);
            counter.innerHTML = totalLoss.formatMoney(0);
        }, 10);

    }
})();
